import { render, staticRenderFns } from "./ChannelPartnerHome.vue?vue&type=template&id=5b5d7f74"
import script from "./ChannelPartnerHome.vue?vue&type=script&lang=js"
export * from "./ChannelPartnerHome.vue?vue&type=script&lang=js"
import style0 from "./ChannelPartnerHome.vue?vue&type=style&index=0&id=5b5d7f74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports